<template>
  <div class="integration-manage">
    <div class="content-center">
      <div class="module-header">
        <div class="module-title">从投标到交付，我们助您实现高效一体化管理</div>
        <div class="module-subtitle">全流程可控，全链路协同，全方位提升项目效能</div>
      </div>
      <div class="module-body">
        <div class="manage-item" :class="{ even: (index + 1) % 2 === 0 }" v-for="(item, index) in dataList" :key="item.id">
          <div class="manage-item-seq">{{ index + 1 }}</div>
          <div class="manage-item-content">
            <img class="manage-item-icon" :src="require(`@/assets/img/home/IntegrationManage/item_icon_${item.id}.png`)">
            <div class="manage-item-title">{{ item.name }}</div>
            <div class="manage-item-text">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dataList: [
        { id: 'tbgl', name: '投标管理', text: '从项目立项到投标执行，实现流程规范与进度可控，提升中标率。' },
        { id: 'htgl', name: '合同管理', text: '全生命周期管理合同条款、审批、履约与归档，降低合同风险。' },
        { id: 'cbgl', name: '成本管理', text: '聚焦预算、费用、结算全过程，实现成本可控、数据透明。' },
        { id: 'fpgl', name: '发票管理', text: '打通业务与财务流，发票开具、验真、归集高效合规。' },
        { id: 'zjgl', name: '资金管理', text: '统一管控资金计划、拨付、回款，保障资金安全与使用效率。' },
        { id: 'gylgl', name: '供应链管理', text: '协同采购、物流、库存，实现资源高效配置与供应稳定。' },
        { id: 'jfgl', name: '交付管理', text: '覆盖生产、实施、验收全流程，确保项目高质量按时交付。' },
      ]
    }
  }
};
</script>

<style lang="less" scoped>
.integration-manage {
  padding: 64px 0;

  .content-center {
    .module-body {
      height: 468px;
      margin-top: 54px;
      background-image: url('@/assets/img/home/IntegrationManage/background.png');
      background-position: center;
      background-repeat: no-repeat;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .manage-item {
        position: relative;
        cursor: default;
        &:hover {
          .manage-item-seq {
            background-color: @primary-color;
            color: #fff;
          }
          .manage-item-content {
            transform: translate(-50%, -12px);
            .manage-item-title {
              color: @primary-color;
            }
          }
          &.even .manage-item-content {
            transform: translate(-50%, 12px);
          }
        }

        .manage-item-seq {
          width: 24px;
          height: 24px;
          background-color: #fff;
          border-radius: 50%;
          line-height: 24px;
          text-align: center;
          font-weight: bold;
          transform: translateY(20px);
          transition: 0.3s ease;
          position: relative;
          &::before,
          &::after {
            content: '';
            width: 12px;
            height: 12px;
            background-color: #fff;
            border-radius: 50%;
            position: absolute;
            bottom: -20px;
            left: 50%;
            transform: translateX(-50%);
          }
          &::after {
            width: 8px;
            height: 8px;
            background-color: #F59E28;
            bottom: -18px;
          }
        }

        .manage-item-content {
          width: 186px;
          height: 222px;
          padding: 20px;
          background-image: url('@/assets/img/home/IntegrationManage/item_background.png');
          background-position: center;
          background-size: 100% 100%;
          position: absolute;
          top: -220px;
          left: 50%;
          transform: translateX(-50%);
          transition: 0.3s ease;
          display: flex;
          flex-direction: column;
          align-items: center;

          .manage-item-icon {
            width: 56px;
            height: 56px;
          }
          .manage-item-title {
            margin-top: 8px;
            font-family: @font-medium;
            line-height: 22px;
            transition: 0.3s ease;
          }
          .manage-item-text {
            margin-top: 11px;
            font-size: 14px;
            color: @info-color;
            text-align: center;
            line-height: 22px;
          }
        }

        &.even {
          .manage-item-seq {
            transform: translateY(-20px);
            &::before {
              bottom: auto;
              top: -20px;
            }
            &::after {
              bottom: auto;
              top: -18px;
            }
          }
          .manage-item-content {
            top: auto;
            bottom: -220px;
            background-image: url('@/assets/img/home/IntegrationManage/item_background_reversal.png');
          }
        }
      }
    }
  }
}
</style>
